<template>
    <div class="col-12 pl-0 pr-0">
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
        </div>
        <div v-else>
            <div class="card pb-3" >
                <div class="d-flex ml-2 mr-2 p-2">
                    <img src="../../assets/Search.svg" alt="search">
                    <input type="text" placeholder="Search Candidates" v-model="candidatesearchText" class="border-0 black60 proximanova fontsize16 pl-2 searchCandidate" name="filter" id="filter">
                </div>
                <div class="horizontalline"></div>
                <div class="d-flex justify-content-between backgroundcolor1 ml-2 mr-2 p-2">
                    <div class="d-flex pointer">
                        <!-- <input type="radio" name="selectAll" class="mt-1" id="selectall"> -->
                        <input type="checkbox" name="selectAll" v-model="selectAllCheckbox" id="selectall" class="mt-1" @click="selectAllApplications">
                        <label class="fontsizemd black proximanova ml-2 mb-0" for="selectall" @click="selectAllApplications">Select All</label>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex pointer mr-4" v-popover:candidateStatusPopover id="moveToPopover">
                            <img src="../../assets/moveTo.svg" class="img-fluid" alt="moveto" >
                            <span class="fontsizemd black proximanova stylebold ml-2">Move to</span>
                        </div>
                        <popover name="candidateStatusPopover" class="postvideomenu" id="videoProfile">
                            <div class="">
                                <div class="p-1 mouseoveraction" >
                                    <span class="pt-1 pl-2 d-flex flex-column"><div class="fontsize12 black80" data-toggle="modal" data-target="#deleteExpModal" @click="updateJobApplicantStatus('Disqualified')">Rejected</div></span>
                                </div>
                                <div class="horizontalline"></div>
                                <div class="p-1 mouseoveraction"  >
                                    <span class="pt-1 pl-1 d-flex flex-column ml-1"><div class="fontsize12 black80" data-toggle="modal" data-target="#deleteExpModal" @click="updateJobApplicantStatus('Review')">Review</div></span>
                                </div>
                                <div class="horizontalline"></div>
                                <div class="p-1 mouseoveraction" >
                                    <span class="pt-1 pl-1 d-flex flex-column ml-1"><div class="fontsize12 black80" data-toggle="modal" data-target="#deleteExpModal" @click="updateJobApplicantStatus('Assessment')">Assessment</div></span>
                                </div>
                                <div class="horizontalline"></div>
                                <div class="p-1 mouseoveraction" >
                                    <span class="pt-1 pl-1 d-flex flex-column ml-1"><div class="fontsize12 black80" data-toggle="modal" data-target="#deleteExpModal" @click="updateJobApplicantStatus('Shortlisted')">Shortlisted</div></span>
                                </div>
                                <div class="horizontalline"></div>
                                <div class="p-1 mouseoveraction"  >
                                    <span class="pt-1 pl-1 d-flex flex-column ml-1"><div class="fontsize12 black80" data-toggle="modal" data-target="#deleteExpModal" @click="updateJobApplicantStatus('Interview')">Interview</div></span>
                                </div>
                                <div class="horizontalline"></div>
                                <div class="p-1 mouseoveraction"  >
                                    <span class="pt-1 pl-1 d-flex flex-column ml-1"><div class="fontsize12 black80" data-toggle="modal" data-target="#deleteExpModal" @click="updateJobApplicantStatus('Selected')">Selected</div></span>
                                </div>
                                <div class="horizontalline"></div>
                                <div class="p-1 mouseoveraction"  > 
                                    <span class="pt-1 pl-1 d-flex flex-column ml-1"><div class="fontsize12 black80" data-toggle="modal" data-target="#deleteExpModal"  @click="updateJobApplicantStatus('Hired')">Hired</div></span>
                                </div>
                            </div>
                        </popover>
                        <!-- <div class="d-flex pointer">
                            <img src="../../assets/JobFilters.svg" class="img-fluid" alt="filters" @click.prevent="openDropDown">
                            <span class="fontsizemd black proximanova stylebold ml-2" @click.prevent="openDropDown">Filters</span>
                        </div> -->
                        <div class="dropdown-menu col-6 col-lg-8 col-md-5" v-if="showdropdown" id = "filterDropdown"  >                                        
                            <div  class="d-flex justify-content-between col-12 mb-2 ml-2 mt-2">
                                <span class="fontsize12 stylebold proximanova black">Filters </span>
                                <div class="">
                                    <img src="../../assets/Close.svg" alt="close" class="img-fluid closebtn float-right hover closebtnmouseover" @click="closeDropDown">
                                </div>
                            </div>
                            <div class="horizontalline mt-2 mb-2"></div>
                            <div class="d-flex input-group col-12 mt-2 mb-2"  >
                                <input class="form-control searchtext font14-opacity60 bigger-font proximanova" type="text"            
                                    placeholder="Search Location" id="locationtext" autocomplete="off"
                                    aria-label="Search"  @input ="searchlocation" v-model="locationText"  
                                />
                                <div class="input-group-append">
                                    <span class="input-group-append img-input-group" id="basic-text1">
                                        <img src="../../assets/Search.svg" class="imgborder1 " alt="search"/>
                                    </span>
                                </div>
                                <div class="dropdown-menu dropdownmenu1 col-10 ml-3 d-flex" id="LocationDropdown" v-if="showLocationDropdown && locationText.length> 0"    > 
                                    <div class="font12-opacity60reg  bigger-font ml-3 hover proximanova">
                                        <li class="list-group-item proximanova" v-for="(item,index) in searchedLocations" :key="index" @click="selectLocation(item.cityName)">
                                            {{item.cityName}}
                                        </li>
                                    </div>
                                </div> 
                            </div>
                            <div class=" col-12 mt-1  font14-opacity60">
                                <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                    <div  v-if="showNewLocations">
                                        <div class="col-6" v-for="(item,index) in newSelectedLocations" :key="index">
                                            <input type="checkbox" v-model="selection.selectedlocations" checked class="form-check-input check-with-label"  :id="item" :value="item">
                                            <label class="font12-opacity60reg label-for-check proximanova" for="index">{{item}}</label>
                                        </div>
                                    </div>
                                    <div class="col-6" v-for="(item,index) in defaultLocations" :key="index">
                                        <input type="checkbox" v-model="selection.selectedlocations" checked="checked" class="form-check-input check-with-label" :id="item" :value="item">
                                        <label class="font12-opacity60reg label-for-check proximanova" for="index">{{item}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-start mr-2 ml-3" v-if="newSelectedLocations.length> 0">
                                <a class="fontsize12 proximanova black pointer" v-if="!showNewLocations" @click="showmore">View More...</a>
                                <a class="fontsize12 proximanova black pointer" v-if="showNewLocations" @click="showless">View Less...</a>
                            </div>
                            <div class="col-12">
                                <div class="horizontalline mt-2 mb-2"></div>
                            </div>
                            <span class="font12-opacity60 ml-3 proximanova" :class="{'text-color' :selection.selectedExperience.length > 0}">Experience</span>
                            <div class=" col-12 mt-1  font14-opacity60">
                                <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                    <div class="col-6" v-for="(item,index) in defualtExperience" :key="index">
                                        <input type="checkbox" v-model="selection.selectedExperience" checked="checked" class="form-check-input check-with-label"  :id="item" :value="item">
                                        <label class="font12-opacity60reg label-for-check proximanova" for="index">{{item}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="horizontalline mt-2 mb-2"></div> 
                            </div>
                            <div class="input-group col-12 mt-2 mb-2"  >
                                <input class="form-control searchtext font14-opacity60 bigger-font proximanova"  type="text"             
                                    placeholder="Search Designation" id="searchdesignation" autocomplete="off"
                                    aria-label="Search"  @input ="searchdesignation" v-model="desigtext"  
                                />
                                <div class="input-group-append ">
                                    <span class="input-group-append img-input-group" id="basic-text1">
                                        <img src="../../assets/Search.svg" class="imgborder1 " alt="search"/>
                                    </span>
                                </div>
                                <div class="dropdown-menu dropdownmenu1 col-10 ml-3 d-flex" id="desigDropdown" v-if="showDesignationDropdown && desigtext.length> 0"   > 
                                    <div class="font12-opacity60reg  bigger-font ml-3 hover">
                                        <li class="list-group-item proximanova" v-for="(item,index) in searchedDesignationList" :key="index" @click="selectDesignation(item.roleName)">
                                            {{item.roleName}}
                                        </li>
                                    </div>
                                </div>
                            </div>
                            <div class=" col-12 mt-1  font14-opacity60">
                                <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                    <div  v-if="showNewDesignation">
                                        <div class="col-6" v-for="(item,index) in newSelectedDesignation" :key="index">
                                            <input type="checkbox" v-model="selection.selectedDesignation" checked class="form-check-input check-with-label"  :id="item" :value="item">
                                            <label class="font12-opacity60reg label-for-check proximanova" for="index">{{item}}</label>
                                        </div>
                                    </div>
                                    <div class="col-6" v-for="(item,index) in defaultDesignation" :key="index">
                                        <input type="checkbox" v-model="selection.selectedDesignation" checked="checked" class="form-check-input check-with-label"  :id="item" :value="item">
                                        <label class="font12-opacity60reg label-for-check proximanova" for="index">{{item}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-start mr-2 ml-3" v-if="newSelectedDesignation.length> 0">
                                <a class="fontsize12 proximanova black pointer" v-if="!showNewDesignation" @click="showmoreDesig">View More...</a>
                                <a class="fontsize12 proximanova black pointer" v-if="showNewDesignation" @click="showlessDesig">View Less...</a>
                            </div>
                            <div class="col-12">
                                <div class="horizontalline mt-2 mb-2"></div> 
                            </div>
                            <span class="fontsize12 black proximanova stylebold ml-3">Sort by</span>
                            <div class=" col-12 mt-1  font14-opacity60">
                                <div class="row d-flex flex-column ml-2 mb-2 mt-2">
                                    <div class="col-6">
                                        <input type="checkbox" class="form-check-input check-with-label"  >
                                        <label class="font12-opacity60reg label-for-check proximanova" for="index">Early Apply</label>
                                    </div>
                                    <div class="col-6">
                                        <input type="checkbox" class="form-check-input check-with-label" >
                                        <label class="font12-opacity60reg label-for-check proximanova" for="index">Status</label>
                                    </div>
                                </div>
                            </div>
                            <div class="horizontalline mt-2 mb-2"></div>
                            <div class="d-flex justify-content-end  pr-3 pt-3 pb-2">
                                <a class="btn button-create btn-color mr-2 border" @click="resetFiltersData" id="search">
                                    <span class="font16-bold proximanova">Reset</span>
                                </a>
                                <a v-on:click="getFilteredData"  class="btn button-create sign-in-button sign-up-button"  id="search">
                                    <span class="bold16px_white proximanova">Show Results</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jobslistverticalscroll">
                <div v-for="(candidate, index) in filteredList" :key="index">
                    <!-- <div class="d-flex flex-column bordertop borderbottom p-3 pl-lg-4 pr-lg-4" :class="{'borderleftblue' :candidateSelected===index}" @click="NavToCandidateDetails"> -->
                    <div class="d-flex bordertop borderbottom p-2 pl-md-2 pr-md-4" :class="{'borderleftblue' :candidateSelected===candidate.profileId, 'sign-in-background':candidate.recruiterViewFlagValue=='Y'}">
                        <div class=" col pl-0 pr-0">
                            <input type="checkbox" name="applicant selection" v-model="applicationIds" :id="'application'+index" :value="candidate.currentApplicationStatus.applicationId">
                        </div>
                        <div class="d-flex flex-column col-12 pl-0 ml-2">
                        <div class="d-flex justify-content-between">
                            <div class="d-flex">
                                <div class="d-flex">
                                    <div class=" mr-2 text-center">
                                        <img v-if="candidate.profilePictureLink" :src="candidate.profilePictureLink" @error="candidate.profilePictureLink = null" width="45px" class="img-fluid border border-dark borderradiushalf rounded-circle loadingBgImg" alt="profilepic">
                                        <!-- <img v-else src="../../assets/Profile_placehlder.svg" width="45px" class="img-fluid border border-dark borderradiushalf rounded-circle" alt=""> -->
                                        <div v-else id="profImage" class=" text-center pointer rounded-circle white" :class="candidate.firstName.charAt(0)">
                                            <p class="white fontsize16 defmargintop text-uppercase">{{candidate.firstName.charAt(0)}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column mt-1">
                                    <span class="fontsizemd black proximanova stylebold pointer applicantName" @click="selectApplicant(index, candidate)" draggable="true" @dragstart="drag(index)" @dragend="dragend">{{candidate.firstName}} {{candidate.lastName}}</span>
                                    <span class="fontsize12 black60 proximanova text-capitalize">{{candidate.designation.roleName}}, {{candidate.companyDetails.companyName}} <span v-if="candidate.country">, {{candidate.country.countryName}}</span></span>
                                    <span class="fontsize12 black60  proximanova">{{ candidate.applicantCreationDate | moment("MMM Do YYYY, h:mm a") }}</span>
                                </div>
                            </div>
                            <div class="justify-content-end" v-if="candidate.currentApplicationStatus !== null">
                                <span class="fontsize10 backgroundcolor3 borderradius10 proximanova white p-1 pl-2 pr-2 mr-1" v-if="candidate.newApplication && candidate.recruiterViewFlagValue!='Y'">New</span>
                                <img src="../../assets/JobDisqualified.svg" class="img-fluid mt-1" alt="disqualified" v-if="candidate.currentApplicationStatus.jobStatus==='Disqualified'">
                                <img src="../../assets/JobReview.svg" class="img-fluid mt-1" alt="review" v-if="candidate.currentApplicationStatus.jobStatus==='Review'">
                                <img src="../../assets/JobAssessment.svg" class="img-fluid mt-1" alt="assessment" v-if="candidate.currentApplicationStatus.jobStatus==='Assessment'">
                                <img src="../../assets/JobShortlisted.svg" class="img-fluid mt-1" alt="shortlisted" v-if="candidate.currentApplicationStatus.jobStatus==='Shortlisted'">
                                <img src="../../assets/JobInterview.svg" class="img-fluid mt-1" alt="interview" v-if="candidate.currentApplicationStatus.jobStatus==='Interview'">
                                <img src="../../assets/JobSelected.svg" class="img-fluid mt-1" alt="selected" v-if="candidate.currentApplicationStatus.jobStatus==='Selected'">
                                <img src="../../assets/JobHired.svg" class="img-fluid mt-1" alt="hired" v-if="candidate.currentApplicationStatus.jobStatus==='Hired'">
                            </div>
                        </div>
                        <div class="horizontalline mt-1 mb-1"></div>
                        <div class="d-lg-flex d-md-flex justify-content-between candidatevideosec">
                            <div class="d-flex pointer" @click="NavToUserTab('videoresume')">
                                <img src="../../assets/VideoProfile.svg" width="25px" class="img-fluid" alt="video">
                                <span class="fontsize12 black proximanova my-auto ml-1 text-nowrap">Video Resume</span>
                            </div>
                            <div class="d-flex pointer" @click="NavToUserTab('videoprofile')">
                                <img src="../../assets/JobVideoProfile.svg" class="img-fluid" alt="video">
                                <span class="fontsize12 black proximanova my-auto ml-1 text-nowrap">Video Profile</span>
                            </div>
                            <div class="d-flex pointer" @click="NavToUserTab('textresume')">
                                <img src="../../assets/JobTextResume.svg" class="img-fluid" alt="resume">
                                <span class="fontsize12 black proximanova my-auto ml-1 text-nowrap">Text Resume</span>
                            </div>
                        </div>
                        <div class="horizontalline mt-1 mb-1"></div>
                        <div v-if="candidate.userKnowledge.length > 0" class="d-flex flex-wrap" >
                            <div v-for="(skill, index) in candidate.userKnowledge" :key="index" >
                                <span v-if="index < 3 " class="pl-3 pr-3 pt-1 mr-2 black60 fontsize12 backgroundcolor8 pb-1 borderadius12 proximanova d-flex mt-1">
                                    {{skill.knowledgeDetails.knowledgeIn}}
                                </span>
                            </div>
                            <span class="fontsize12 black60 proximanova mt-2">More...</span>
                        </div>
                        <div v-else class="text-center">
                            <span class="fontsize12 black60 proximanova mt-2">No skills set available</span>
                        </div>
                        </div>
                    </div>
                    <div class="borderbottomjob"></div>
                </div>
                </div>
            </div>
            <div class="modal fade" id="deleteExpModal" tabindex="-1" role="dialog" aria-labelledby="deleteExpModalLabel" aria-hidden="true">
                <div class="modal-dialog modalBody" role="document">
                    <div class="modal-content">
                        <div class="modal-header delete-modal border-0">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span> </button>                                           
                        </div>     
                        <div class="modal-body modal-delete text-center p-3">
                            <div class="text-center proximanova fontsize16 black" v-if="applicationIds.length > 0">Are you sure to move selected applications to {{selectedJobStatus}} status? </div>
                            <div class="text-center proximanova fontsize16 black" v-else>You didn't choose any application to update status...</div>
                            <div class="pt-3 pb-2">
                                <button class="button-cancel-font modaldeletebtn border borderradius20 p-1 pr-4 pl-4 pointer" data-dismiss="modal" aria-label="Close" v-if="applicationIds.length > 0">No</button>
                                <button class="button-cancel-font backgroundcolorblack white borderradius20 p-1 border ml-2 pr-4 pl-4 pointer" :disabled="updateApplicationStatusBtnClicked" v-if="applicationIds.length > 0" @click="SubmitUpdateApplicationsStatus">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
    </div>
</template>
<script>
import { bus } from "@/main.js";
import httpuserprofile from "@/js/http-userprofile.js";
import httppostajob from "@/js/http-postjob.js"
import httpbusiness from "@/js/http-business.js"
import $ from 'jquery'
import router from '../../router';
import httpjob from "@/js/http-postjob.js"
import APIErrorModal from '../../components/APIerrorpopup.vue'
import sessionUtils from "@/js/session-util.js";
export default {
    components:{
      APIErrorModal
    },
    data(){
        return{
            displayAPIerrorModal : false,
            pageloader : true,
            companyName : null,
            companyProfileId : null,
            jobId : null,
            skillsList : ['java', 'html', 'css', 'javascript'],
            candidatesList : [],
            candidatesListStatus : 'Total',
            candidateSelected : null,
            draggedIndex : null,
            //filters data
            candidatesearchText : "",
            selection : {
                selectedlocations: [],
                selectedExperience: [],
                selectedDesignation: [],
                selectedCompany: [],
                selectedEducation :[]
            },
            defaultLocations : ['Hyderabad','Bangalore','Delhi','Pune'],
            defualtExperience : ['1 to 2 yrs','2 to 5 yrs','5 to 8 yrs','8+ yrs'],
            defaultDesignation : ['Manager','Product Manager','Designer','Business'],
            showdropdown : false,
            //location
            locationText : '',
            searchedLocations : [],
            showLocationDropdown : false,
            newSelectedLocations : [],
            showNewLocations : false,
            //designation
            desigtext : '',
            searchedDesignationList : [],
            showDesignationDropdown : false,
            newSelectedDesignation : [],
            showNewDesignation : false,
            ///update job status
            companyUserEmail : null,
            selectAllCheckbox : false,
            applicationIds : [],
            selectedJobStatus : null,
            updateApplicationStatusBtnClicked : false
        }
    },
    mounted() {
        this.jobId = sessionUtils.getSelectedJobId();
        this.companyProfileId = sessionUtils.getCompanyProfileId()
        this.companyName = sessionUtils.getRecruiterCompanyName();
        this.companyUserEmail = sessionUtils.getCompanyEmail();
        this.getAllApplicantsList()
        bus.$on("getCandidatesByStatus", data => {
            this.candidatesListStatus = data;
            if(data !== 'Total') {
                this.candidatesList = []
                this.getApplicantsListByJobStatus(data)
            }else{
                this.candidatesList = []
                this.getAllApplicantsList()
            }
        })
        bus.$on("updateJobApplicantsInformation", data => {
            if(data.status){
                console.log("in update applicants list")
                this.getAllApplicantsList()
            }
        })
    },
    computed:{
        filteredList(){
            return this.candidatesList.filter(candidate => {
                let fullname = candidate.firstName + ' ' + candidate.lastName
                return fullname.toLowerCase().includes(this.candidatesearchText.toLowerCase())
            });
        },
    },
    methods : {
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        //this will invoke after component is mounted get applicants list based on jobId
        getAllApplicantsList(){
            this.pageloader = true;
            httpjob.get('/postjob/getListOfJobApplicants?jobId='+this.jobId)
            .then((response) => {
                this.pageloader = false;
                console.log("job applicants list : ", response)
                let appliedCandidatesList = response.data;
                for(var i =0; i < appliedCandidatesList.length; i++){
                    if(appliedCandidatesList[i].applicantStatus.length > 0){
                        appliedCandidatesList[i].currentApplicationStatus = appliedCandidatesList[i].applicantStatus[0];
                    }else{
                        appliedCandidatesList[i].currentApplicationStatus = null
                    }
                    if(appliedCandidatesList[i].applicantCreationDate){
                    appliedCandidatesList[i].newApplication = isToday(new Date(appliedCandidatesList[i].applicantCreationDate));
                    }
                }
                this.candidatesList = appliedCandidatesList;
                if(this.candidatesList.length > 0 && screen.width > 900){
                    this.displayDefaultUserInfo()
                }
                if(this.candidatesList && this.candidatesList.length < 1){
                    bus.$emit('whenJobDontHaveApplicants', true)
                }
                //check application is new or not
                function isToday(date) {
                    const today = new Date();
                    if (today.toDateString() === date.toDateString()) {
                        return true;
                    }
                    return false;
                }
                console.log("applications list : ", this.candidatesList)
            }).catch((e) => {
                this.pageloader = false;
                console.log(e.response)
            })
        },
        displayDefaultUserInfo(){
            console.log("clicked")
            var candidates = document.getElementsByClassName('applicantName')
            console.log(candidates)
            setTimeout(function() {
                candidates[0].click()
            },2000);
        },
        selectAllApplications() {
            this.selectAllCheckbox = !this.selectAllCheckbox
            console.log("flag value for select all : ", this.selectAllCheckbox)
            if(this.selectAllCheckbox){
                for(var i = 0; i < this.candidatesList.length; i++){
                    if(this.candidatesList[i].currentApplicationStatus){
                        this.applicationIds.push(this.candidatesList[i].currentApplicationStatus.applicationId)
                    }
                }
                console.log("in true section : ", this.applicationIds)
            }else{
                this.applicationIds = [];
                console.log("in false section : ", this.applicationIds)
            }
        },
        updateJobApplicantStatus(jobStatus) {
            this.selectedJobStatus = jobStatus;
            var popover = document.getElementById('moveToPopover')
            if(popover){
                popover.click()
            }
            var id = "#deleteExpModal"
            $(id).modal('show')
            console.log("selected applicationIds : ", this.applicationIds)
        },
        SubmitUpdateApplicationsStatus(){
            let jobobj = {
                applicationId : null,
                jobStatus : this.selectedJobStatus,
                seq : null,
                comments : null,
                creationUserI : this.companyUserEmail
            }
            this.updateApplicationStatusBtnClicked = true;
            console.log("obj : ", jobobj)
            console.log("selected applicationIds : ", this.applicationIds)
            httppostajob.post('/postjob/updateJobApplicantStatus?jobId='+this.jobId+'&applicationIdList='+this.applicationIds, jobobj, {
            }).then((response) => {
                console.log("update status : ", response)
                this.applicationIds = [];
                this.selectAllCheckbox = false;
                this.updateApplicationStatusBtnClicked = false;
                var id = "#deleteExpModal"
                $(id).modal('hide')
                let obj = {
                    status : true
                }
                this.pageloader = true;
                bus.$emit("updateJobApplicantsInformation", obj)
            }).catch((e) => {
                console.log(e)
                this.updateApplicationStatusBtnClicked = false;
                this.displayAPIerrorModal = true;
            })
        },
        //this will invoke after click on any of the job status on to job details card
        getApplicantsListByJobStatus(jobStatus){
            this.pageloader = true;
            httpuserprofile.get('/userprofile/getCountOfApplicantsOnStatusType?statusText='+jobStatus+'&jobId='+this.jobId)
            .then((response) => {
                this.pageloader = false;
                console.log("job applicants list : ", response)
                let appliedCandidatesList = response.data;
                for(var i =0; i < appliedCandidatesList.length; i++){
                    if(appliedCandidatesList[i].applicantStatus && appliedCandidatesList[i].applicantStatus.length > 0){
                        appliedCandidatesList[i].currentApplicationStatus = appliedCandidatesList[i].applicantStatus[0];
                    }else{
                        appliedCandidatesList[i].currentApplicationStatus = null
                    }
                }
                this.candidatesList = appliedCandidatesList;
                if(this.candidatesList.length > 0 && screen.width > 900){
                    console.log("inside data get : ", screen.width)
                    this.displayDefaultUserInfo()
                }
                // if(this.candidatesList && this.candidatesList.length < 1){
                //     bus.$emit('whenJobDontHaveApplicants', true)
                // }
            }).catch((e) => {
                this.pageloader = false;
                console.log(e.response)
            })
        },
        //this will invoke after click on candidate name to select the card and display selected user details in details component
        selectApplicant(index, candidate){
            // this.candidateSelected = index;
            this.candidateSelected = candidate.profileId;
            // if(candidate.currentApplicationStatus){
            //     jobStatus
            // }
            let obj = {
                userId : candidate.userId,
                userCurrentStatus : candidate.currentApplicationStatus
            }
            // if(candidate.currentApplicationStatus){
            //     obj.userCurrentStatus = candidate.currentApplicationStatus.jobStatus
            // }
            this.$session.set("selectedApplicantId", candidate.userId);
            bus.$emit('applicantSelection', obj)
            if(screen.width < 900) {
                console.log("check1", screen.width)
                router.push({
                    name : 'candidate_details'
                })
            }
            if(candidate.recruiterViewFlagValue == 'N'){
                console.log("into view applucation")
                httpbusiness.post("/business/insertEmpJobApplicantViewe?profileId="+candidate.profileId+"&jobId="+this.jobId+"&applicationId="+candidate.currentApplicationStatus.applicationId+"&viewedEmailId="+this.companyUserEmail)
                .then((response) => {
                    console.log("response afer view : ", response)
                    candidate.recruiterViewFlagValue = 'Y'
                }).catch((e) => {
                    console.log(e)
                })
            }
        },
        //this will invoke after click on video resume/ video profile/ text resume
        // it will open the candidate tab directly
        NavToUserTab(tabName){
            bus.$emit('openUserDetailsTab', tabName)
        },
        drag : function(event, index){
            console.log(event)
            this.draggedIndex = index
        },
        dragend : function(event){
            console.log("drag end : ", event)
            // this.candidatesList.splice(index, 1)
            console.log(event.clientY)
            console.log(window.outerHeight)
            console.log(window.scrollY)
            // if(window.scrollY <= 300 && window.scrollY >= 0){
            if(event.clientY <= 320){
                bus.$emit('IntecreaseCount', 'candidate');
                this.candidatesList.splice(this.draggedIndex, 1)
            }
            this.draggedIndex = null
        },
        openDropDown(){
            this.showdropdown = true;
        },
        closeDropDown(){
            this.showdropdown = false;  
        },
        NavToCandidateDetails() {
            if(screen.width < 900) {
                router.push({
                    name : 'candidate_details'
                })
            }
        },
        //this will invoke after enter text on location search box
        searchlocation(){
            if(this.locationText.length < 1  ){ 
                this.searchedLocations  = [];       
                return;
            }   
            var self = this;
            setTimeout(function() {
                httpuserprofile.get('/searchController/searchbyLocation?searchText='+self.locationText+'&stateCode=')
                .then(response => {    
                    self.searchedLocations = [];    
                    self.searchedLocations = response.data;
                    if(self.searchedLocations.length > 0){
                        self.showLocationDropdown  = true;
                    }                
                })     
            }, 1500); 
        },
        //this will invoke after click on location after seraching
        selectLocation(name){
            this.selection.selectedlocations = this.selection.selectedlocations.concat(name);     
            this.newSelectedLocations = this.newSelectedLocations.concat(name);   
            this.searchedLocations = [];
            this.locationText = '';
            this.showLocationDropdown  = false;
        },
        //this will invoke after click on showmore button to display new locations
        showmore(){
            this.showNewLocations = true;
        },
        //this will invoke after click on showless button to hide new locations
        showless(){
            this.showNewLocations = false;
        },
        //this will invoke after enter characters in designation search input
        searchdesignation(){
            if(this.desigtext.length < 1  ){ 
                this.searchedDesignationList  = [];       
                return;
            }   
            var self = this;
            setTimeout(function() {
                httpuserprofile.get('/searchController/searchByRoleType?roleType='+self.desigtext)
                .then(response => {   
                    self.searchedDesignationList = [];    
                    self.searchedDesignationList = response.data;
                    self.showDesignationDropdown = true;  
                })     
            }, 1000);
        },
        //this will invoke after select value from serached list of designation
        selectDesignation(text){
            this.selection.selectedDesignation = this.selection.selectedDesignation.concat(text);      
            this.newSelectedDesignation = this.newSelectedDesignation.concat(text);   
            this.searchedDesignationList = [];
            this.desigtext = '';   
            this.showDesignationDropdown = false;
        },
        //this will invoke after click on showmore button to display new designations
        showmoreDesig(){
            this.showNewDesignation = true;
        },
        //this will invoke after click on showless button to hide new designations
        showlessDesig(){
            this.showNewDesignation = false;
        },
        resetFiltersData(){
            this.selection.selectedlocations = [];
            this.selection.selectedExperience=[];
            this.selection.selectedDesignation = [];
            this.newSelectedLocations = [];
            this.newSelectedDesignation = [];
        },
        getFilteredData() {
            console.log("filtered data")
        }
    },
    beforeDestroy(){
        bus.$off('applicantSelection')
        bus.$off('openUserDetailsTab')
        bus.$off('getCandidatesByStatus')
        bus.$off('updateJobApplicantsInformation')
        bus.$off('whenJobDontHaveApplicants')
    },
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.searchCandidate{
    width: 80%;
}
.borderradiushalf{
    padding: 2px;
}
.searchCandidate:focus{
    outline: none;
}
.pageloader{
    width: 10% !important;
}
#profImage{
    width: 45px;
    height: 45px;
    border:1px solid #ced4da;
}
.postvideomenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.postvideomenu.dropdown-position-bottom {
  left: unset !important;
  top: 70px !important;
  width: 150px !important;
  padding: 5px 10px 5px 10px !important;
  transform: translate3d(-25%, 10px, 10px) !important;
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
#deleteExpModal{
  margin-top: 15%;
  padding-right: 0px !important;
}
/* filter dropdown */
.dropdown-menu{
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  top: 0;
  right: 0;
  z-index: 3;
  left: unset !important;
  margin-top: 75px;   
  border-radius: 10px  !important;
}
.dropdownmenu1{
    display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  left: 0 !important;
  margin-top: 35px;   
  border-radius: 10px  !important;
}
.closebtnmouseover {
    border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.input-group-append{
  margin-left: 0  !important;
}
.searchtext{
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
.form-control:focus{
  outline: none !important;
  box-shadow: none !important;   
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
.input-group-append{
  margin-left: 0  !important;
}
.imgborder1 {
  padding: 11px 15px 11px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.list-group-item{
  padding: .25rem 0.25rem;
  border: none;
  cursor: pointer;
}
@media screen and (max-width: 1050px) and (min-width : 1020px) {
  .candidatevideosec{
      display: flex !important;
      flex-direction: column !important;
  }
}
@media screen and (min-width: 770px) {
    .jobslistverticalscroll{
        height: 130vh !important;
        overflow: auto;
    }
    /* .jobslistverticalscroll::-webkit-scrollbar {
        display: none;
    } */
}
</style>